import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { createElementTickmarkRequest } from 'api/tickmark-api';
import CreateTickmarkModal from 'components/feature/element-panel/tickmark-panel/create-tickmark-modal';
import { getElementTickmarksAndUpdateElementCache } from 'store/actions/element-panel-actions';
import { updateElementCacheByCalloutAction } from 'store/actions/element-cache-actions';

const CreateTickmarks = ({ show, setShow, onCloseModal, elementDetails }) => {
  const dispatch = useDispatch();
  const socketHasBeenDisconnected = useSelector(
    (state) => state.sockets.statementSocket.socketHasBeenDisconnected,
  );

  const onClose = () => {
    setShow(false);
    if (onCloseModal) {
      onCloseModal();
    }
  };

  const onCreate = async ({ tickmarkModel }) => {
    await createElementTickmarkRequest({ tickmarkModel });
    dispatch(
      updateElementCacheByCalloutAction({
        elementIds: [elementDetails.id],
        showCallout: true,
      }),
    );
    onClose();
    if (socketHasBeenDisconnected) {
      dispatch(getElementTickmarksAndUpdateElementCache(elementDetails));
    }
  };

  return (
    <>
      {show && (
        <CreateTickmarkModal
          title="quick-actions.create-tickmark-modal.title"
          onClose={onClose}
          onCreate={onCreate}
          elementDetails={elementDetails}
        />
      )}
    </>
  );
};

export default CreateTickmarks;

CreateTickmarks.propTypes = {
  // Property to control the visibility of the modal
  show: PropTypes.bool.isRequired,
  // Function to handle closing the modal
  onClose: PropTypes.func.isRequired,
  // Function to handle the creation of a new tickmark
  onCreate: PropTypes.func.isRequired,
  // Details of the element for which the tickmark is being created
  elementDetails: PropTypes.object.isRequired,
};
